import PopupRedesigned from './PopupRedesigned'

import { useState } from 'react'

import ActiveChatMessageView from '../ChatMessenger/ActiveChatMessageView'
import ChatMessengerControls from '../ChatMessenger/ChatMessengerControls'

interface Props {
    onClose: () => void
}

const Popup = ({ onClose }: Props) => {
    const [popupChildrenHeight, setPopupChildrenHeight] = useState(0)

    const getPopupHeight = (height: number) => {
        setPopupChildrenHeight(height)
    }

    const handleClose = () => {
        onClose()
    }

    return (
        <PopupRedesigned subject="Chat" onClose={handleClose} getHeight={getPopupHeight}>
            <ActiveChatMessageView isExpanded />
            <ChatMessengerControls isExpanded/>
        </PopupRedesigned>
    )
}

export default Popup
